import React, { Component } from "react";
import { observer } from "mobx-react"
import { Provider } from "mobx-react"
import { Icon, Switch, Collapse, List } from 'antd'
import EventCards from '../layoutComponents/EventCards'
import OracleEventCards from '../layoutComponents/OracleEventCards'
import EventsByCategory from "../layoutComponents/EventsByCategory";
import CategoryListItems from './CategoryListItems';
import OracleCategoryListItems from './OracleCategoryListItems';
const Panel = Collapse.Panel;

@observer(["CategoriesStore", "TeamStore", "AdminStore", "ViewStore", "eventStore", "web3Store"])
class FeaturedEvents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            featuredTeamList: [],
            listToDisplay: [],
            showDefault: true,
            eventList: [],
            eventsChecked: false,
            oracleEventList: [],
            oracleEventsChecked: false,
            previousTotalFeatEvents: 0,
            previousTotalOracleEvents: 0,
            eventsToDisplay: "",
            categories: []
        };
        this.switchChange = this.switchChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    switchChange(checked) {
        console.log(checked);
        this.setState({ showDefault: checked, listToDisplay: checked ? <CategoryListItems oracles={false} eventList={this.state.eventList} /> : <OracleCategoryListItems  eventList={this.state.eventList}/> });
    }

    componentDidMount() {
        const { eventStore, CategoriesStore } = this.props;
        // setTimeout(() => {
        //     this.setState({ categories: CategoriesStore.categories });
        // }, 100);
        this.setState({listToDisplay: <CategoryListItems oracles={false} eventList={this.state.eventList} />})

    }

    async componentWillMount() {
        const { eventStore } = this.props;
        this.props.ViewStore.changeView('Events');
        this.props.ViewStore.changeCurrentPage('FeaturedEvents');
        const { TeamStore } = this.props;
        TeamStore.queryTeams();

        eventStore.queryEvents();
        // if (eventStore.events.values().length > this.state.previousTotalFeatEvents) {
        //     this.setState({ eventList: [] });
        //     this.renderEvents();

        // }
        // this.props.eventStore.querySingleEvent('0xf677b6ba1a5c317de0dae6dfa66d52f61a61f2f75d6da3295d2c559f4f94b1b8');
    }

    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('FeaturedEvents');
    }

    handleClick() {
        this.props.ViewStore.changeGridList()
    }

    renderEvent(event) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();
        return (
            <EventCards
                key={event._id}
                event={event} />
        );
    }

    renderOracleEvent(event) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();
        return (
            <OracleEventCards
                key={event._id}
                event_id={event._id}
                event={event}
                bytes32_id={event.bytes32Id}
                start_time={startTimeString}
                startTimeNumber={event.startTime}
                duration={event.duration}
                categoryId={event.categoryId}
                team_one={event.teams[0]}
                team_two={event.teams[1]} />
        );
    }

    renderEventCollapse(event) {
        const { TeamStore } = this.props;
        let teams = [];
        event.teams.forEach(team => {
            teams.push(TeamStore.teams.get(team))
        });
        console.log("teams for " + event._id + " -- " + JSON.stringify(teams))

        return <Panel header={teams[0].name + " vs " + teams[1].name + (teams.length > 2 ? " and " + (teams.length - 2) + " more" : "")} key={event._id}>
            <p>{event.teams[1]}</p>
        </Panel>
    }

    renderEventDiv(event) {
        const { TeamStore } = this.props;
        let teams = [];
        event.teams.forEach(team => {
            teams.push(TeamStore.teams.get(team))
        });
        return <div style={{ textAlign: "center", width: "100%" }}>
            <p>{teams[0].name + " vs " + teams[1].name + (teams.length > 2 ? " and " + (teams.length - 2) + " more" : "")}</p>
            <img style={{ position: "relative", right: "40%", bottom: "10px" }} height="7%" width="7%" src={teams[0].logoUrl} />
            <img style={{ position: "relative", left: "40%", bottom: "10px" }} height="7%" width="7%" src={teams[1].logoUrl} />
            <div style={{ position: "relative", bottom: "15px" }} className="raleway">{new Date(event.startTime).toLocaleDateString()}</div>
            <button>Place Bet</button>
            <div style={{ width: "100%", backgroundColor: "rgba(255,255,255,0.1)", height: "2px" }} />
            {event.relatedPropEvents.length > 0 ? <Collapse>
                <Panel header="View Prop Bets" key="1">Prop BEts  .....</Panel></Collapse> : ""}
            <br />
        </div>
    }

    renderEvents() {
        const { eventStore, AdminStore } = this.props;
        let eventList = this.state.eventList;
        let timeNow = new Date().getTime() / 1000;
        // console.log('Time now:' + timeNow);
        if (eventList.length == 0 && !this.state.eventsChecked) {
            eventList = [];
            for (let event of eventStore.events.values()) {

                if (event.startTime + event.duration > timeNow) {
                    if (!event.cancelled && !event.finalized && !event.isPropEvent) {
                        //eventList.push(this.renderEventCollapse(event));
                        eventList.push(this.renderEventDiv(event));
                    }
                }
            }
            this.setState({
                eventList: eventList, previousTotalFeatEvents: eventList.length, eventsChecked: true
                , eventsToDisplay: (eventList.length > 0 ?
                    <div style={{ backgroundColor: "rgba(0,0,0,0.3)", paddingTop: 40, paddingBottom: 40, paddingLeft: 20, paddingRight: 20 }}>
                        {eventList}
                    </div>
                    : <div className="my-bets-page-cards-bet-options-title">
                        <Icon style={{ padding: 10, fontSize: "30px" }} type="calendar" /><h3>No Events Found</h3>
                    </div>)
            });
        } else {
            this.setState({
                eventsToDisplay: (eventList.length > 0 ?
                    <div style={{ backgroundColor: "rgba(0,0,0,0.3)", paddingTop: 40, paddingBottom: 40, paddingLeft: 20, paddingRight: 20 }}>
                        {eventList}
                    </div>
                    : <div className="my-bets-page-cards-bet-options-title">
                        <Icon style={{ padding: 10, fontSize: "30px" }} type="calendar" /><h3>No Events Found</h3>
                    </div>)
            })
        }
    }

    componentWillUpdate() {
        const { eventStore, AdminStore } = this.props;
        if (eventStore.events.values().length > this.state.previousTotalFeatEvents) {
            this.setState({ eventList: [] });
            this.renderEvents();

        }
    }

    renderOracleEvents() {
        const { eventStore, AdminStore } = this.props;
        let oracleEventList = this.state.oracleEventList;
        let timeNow = new Date().getTime() / 1000;
        //   console.log('Time now:' + timeNow);
        if (oracleEventList.length == 0 && !this.state.oracleEventsChecked) {
            for (let event of eventStore.events.values()) {
                if (event.startTime + event.duration < timeNow && timeNow < event.startTime + event.duration + Number(AdminStore.oraclePeriod)) {
                    if (!event.cancelled && !event.finalized && !event.isPropEvent) {
                        oracleEventList.push(this.renderOracleEvent(event));
                    }
                }
            }
            this.setState({ oracleEventList: oracleEventList, oracleEventsChecked: true });
            return (oracleEventList.length > 0 ? oracleEventList : <div className="my-bets-page-cards-bet-options-title">
                <Icon style={{ padding: 10, fontSize: "30px" }} type="calendar" /><h3>No Oracle Events Found</h3>
            </div>);
        } else {
            return (oracleEventList.length > 0 ? oracleEventList : <div className="my-bets-page-cards-bet-options-title">
                <Icon style={{ padding: 10, fontSize: "30px" }} type="calendar" /><h3>No Oracle Events Found</h3>
            </div>);
        }
    }

    render() {
        let gridColumnEvents = "";
        let gridListIcon = "";
        const { CategoriesStore } = this.props;
        if (this.props.ViewStore.getHeaderState === true) {
            gridColumnEvents = '100%';
        } else {
            if (this.props.ViewStore.getGridList === "list") {
                gridListIcon = <Icon type="appstore" onClick={this.handleClick} />
                gridColumnEvents = '100%';
            } else {
                gridListIcon = <Icon type="bars" onClick={this.handleClick} />
                gridColumnEvents = '49.2% 49.2%';
            }
        }
        const { eventStore, TeamStore } = this.props;


        return (
            <Provider>
                <div className="featured-events-wrap">
                    {/* <div className="view-options">
                        <div className="grid-list-switch"><Switch onChange={this.switchChange} checkedChildren="BETTING" unCheckedChildren="ORACLES" defaultChecked /></div>
                        <div className="grid-list-icon">{gridListIcon}</div>
                    </div> */}
                    <div className="grid-list-switch"><Switch onChange={this.switchChange} checkedChildren="BETTING" unCheckedChildren="ORACLES" defaultChecked /></div>
                    <div className="main-page-cards" >
                        {/* style={{ gridTemplateColumns: gridColumnEvents }} */}
                        {//this.state.showDefault ?
                            // !CategoriesStore.loading ?
                            //  this.state.eventsToDisplay
                            <div>



                                {/* <List.Item key={"basketball"} style={{ padding: "15px" }}>
                                            <EventsByCategory category="5c1ad3c79369990004eb700e" eventList={this.state.eventList} />
                                        </List.Item>
                                        <List.Item key={"hockey"} style={{ padding: "15px" }}>
                                            <EventsByCategory category="5c11e43f0b77aa00043b516f" eventList={this.state.eventList} />
                                        </List.Item> */}
                             {/* {!this.state.showDefault ?   <CategoryListItems oracles={true} eventList={this.state.eventList} /> : 
                             <CategoryListItems oracles={false} eventList={this.state.eventList} /> }
                            */}

                                {
                                    // CategoriesStore.categories.forEach((category) => {
                                    //     console.log("This cat " + category.title);

                                    this.state.listToDisplay

                                    //})

                                }

                            </div>
                            // : (eventStore.isLoading() ? <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" /> : "No Live events found.")
                            // : this.renderOracleEvents()
                        }
                    </div>
                </div>
            </Provider>
        );
    }
}
export default FeaturedEvents;


// WEBPACK FOOTER //
// ./src/components/appComponents/FeaturedEvents.js